import { render, staticRenderFns } from "./AcceptTaskDialog.vue?vue&type=template&id=bd65896e&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./AcceptTaskDialog.vue?vue&type=script&lang=js"
export * from "./AcceptTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./AcceptTaskDialog.vue?vue&type=style&index=0&id=bd65896e&prod&lang=css"
import style1 from "./AcceptTaskDialog.vue?vue&type=style&index=1&id=bd65896e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd65896e",
  null
  
)

export default component.exports